// Copyright (c) Mysten Labs, Inc. — DGC Labs footer
// SPDX-License-Identifier: Apache-2.0

import { Text } from '@mysten/ui';

import { footerLinks, footerLogoLink, socialLinks } from './footerLinks';
import { Link } from '~/ui/Link';

function FooterLinks() {
	return (
		<div className="flex flex-col items-center justify-center gap-6 md:flex-row md:justify-end">
			<ul className="flex flex-wrap justify-center gap-4 md:flex-row md:gap-6">
				{footerLinks.map(({ title, to, href }) => (
					<li key={to ?? href}>
						<Link variant="text" {...(to ? { to } : { href })}>
							<Text variant="body/medium" className="text-[#dce1fb]">
								{title}
							</Text>
						</Link>
					</li>
				))}
			</ul>

			{socialLinks.length > 0 ? (
				<ul className="flex justify-center gap-6">
					{socialLinks.map(({ children, href }) => (
						<li key={href}>
							<Link variant="text" href={href}>
								<div className="mt-2" style={{ color: '#dce1fb' }}>
									{children}
								</div>
							</Link>
						</li>
					))}
				</ul>
			) : null}
		</div>
	);
}

function BrandLink() {
	return (
		<div className="flex items-center gap-1">
			<Text variant="body/normal" className="text-[#dce1fb]">
				由
			</Text>{' '}
			<Link variant="text" href={footerLogoLink.href}>
				<Text variant="body/semibold" className="text-[#dce1fb]">
					{footerLogoLink.title}
				</Text>
			</Link>
			<Text variant="body/normal" className="text-[#dce1fb]">
				提供 · Main
			</Text>
		</div>
	);
}

function Footer() {
	return (
		<footer className="sticky top-[100%] bg-[#1E293B] px-2 py-10 md:px-5 md:py-6 print:hidden">
			<nav className="flex flex-col justify-center gap-4 divide-y divide-solid divide-gray-45 md:gap-7.5">
				<div className="flex flex-col-reverse items-center gap-7.5 md:flex-row md:justify-between ">
					<div className="hidden self-center text-hero-dark md:flex">
						<BrandLink />
					</div>
					<div>
						<FooterLinks />
					</div>
				</div>
			</nav>
			<div className="mt-4 flex justify-center border-t border-solid border-gray-45 pt-5 text-hero-dark md:hidden md:self-start">
				<BrandLink />
			</div>
		</footer>
	);
}

export default Footer;
